import type { ISocialApply } from "@bbj-types/socialApply";
import type { IFup } from "@bbj-types/socialApply/fup";
import type { ObjectId, Override } from "@bbj-types/utils";
import type { TFupModalRecipient } from "@candidate/views/modals/FupModal/referent/recipient/resolver";
import type { TEmailForm } from "@data-display/EmailForm/resolver";
import { useCallback } from "react";
import { axios } from "../axios";

export type ISendFupPatchBody = {
  fup: Omit<IFup, "partner">;
  email: Override<TEmailForm, { attachments?: ObjectId[] }>;
  userPartner: Required<TFupModalRecipient>;
};

export const usePatchSendFup = () => {
  const [state, execute, cancel] = axios<ISocialApply, ISendFupPatchBody, unknown>(
    {
      url: "/applies/social/:id/fup/partner",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: ObjectId, data: ISendFupPatchBody) => {
      return execute({
        url: `/applies/social/${id}/fup/partner`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
